import React from 'react';
import LoginForm from "./admin/LoginForm";
import {Redirect, Route, Switch} from "react-router-dom";
import CustomerOverview from "./customer/CustomerOverview";
import CustomerDetails from "./customer/CustomerDetails";
import PrivateCoreLoginForm from "./customer/private/PrivateCoreLoginForm";
import PrivateMain from "./customer/private/PrivateMain";
import {CREATE_MODE, VIEW_MODE} from "./constants";
import LanguageOverview from "./languages/LanguageOverview";
import LanguageDetails from "./languages/LanguageDetails";
import LanguageDynamicEditor from "./languages/LanguageDynamicEditor";

// TODO: Hide menu bar if pattern is customers/*/private, cause the private part has its own menu
const Main = () => (
    <div className="main">
        <Switch>
            <Route exact path='/'>
                <Redirect to={'/customers'} />
            </Route>
            <Route exact path='/login' component={LoginForm}/>
            {/*/!* both /roster and /roster/:number begin with /roster *!/*/}
            <Route exact path='/customers' component={CustomerOverview}/>
            <Route exact path='/customers/create' render={() => <CustomerDetails mode={CREATE_MODE}/>}/>
            <Route exact path='/customers/:id' render={() => <CustomerDetails mode={VIEW_MODE}/>}/>
            <Route exact path='/customers/:id/private/login' component={PrivateCoreLoginForm}/>
            <Route exact path='/i18n' component={LanguageOverview}/>
            <Route exact path='/i18n/editor' component={LanguageDynamicEditor}/>
            <Route exact path='/i18n/create' component={() => <LanguageDetails mode={CREATE_MODE}/>}/>
            <Route exact path='/i18n/:id' component={() => <LanguageDetails mode={VIEW_MODE}/>}/>
            <Route path='/customers/:id/private' component={PrivateMain}/>
        </Switch>
    </div>
);

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.js